/* Collection cards: a tap anywhere on the card opens the product, except on links, buttons, inputs,
   the rating and the buy-box sheet. No overlay, so the ADD TO CART button keeps its own tap. ASCII only. */
(function () {
  if (window.__dbCardTapInit) return;
  window.__dbCardTapInit = true;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('product-card');
    if (!card) return;
    if (t.closest('a, button, input, label, select, textarea, product-form, form, [data-card-buybox-root], .jdgm-widget, [role="dialog"]')) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var sel = window.getSelection && window.getSelection();
    if (sel && String(sel).length > 0) return;
    var link = card.querySelector('.product-card__title[href], a.product-card__media[href]');
    if (!link) return;
    e.preventDefault();
    window.location.href = link.href;
  });
})();
